var React = require('react');

function CheckBlack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000","stroke":"#000","d":"M16.5 9.146a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z","key":0}),React.createElement("path",{"fill":"#fff","fillRule":"evenodd","stroke":"#fff","strokeWidth":".5","d":"M5.773 9.25a.416.416 0 0 1 0-.557.346.346 0 0 1 .516 0l2.348 2.535a.416.416 0 0 1 0 .556.346.346 0 0 1-.516 0L5.773 9.25Z","clipRule":"evenodd","key":1}),React.createElement("path",{"fill":"#fff","fillRule":"evenodd","stroke":"#fff","strokeWidth":".5","d":"M11.737 6.993a.34.34 0 0 1 .516-.013c.135.146.14.38.01.533l-3.581 4.232a.34.34 0 0 1-.516.013.408.408 0 0 1-.011-.533l3.582-4.232Z","clipRule":"evenodd","key":2})]);
}

CheckBlack.defaultProps = {"width":"20","height":"20","fill":"#FFF","viewBox":"0 0 17 18"};

module.exports = CheckBlack;

CheckBlack.default = CheckBlack;
